import { useState } from 'react';
import Modal from '@mui/material/Modal';
import { TextField } from '@mui/material';

import { DB, Constant } from '../../constants';
import { aesUtil } from '../../utilities/AesEncryptDecrypt';
import "./style.css";
import { ApiConfig } from '../../configuration';
import { useTranslation } from 'react-i18next';

const ModalChangeUserPasswordInput = (props) => {

    const {open, title, onCancel, userIdToBeChange} = props
    const [requiredPasswordAlert, setRequiredPasswordAlert] = useState(false);
    const [incorrectPasswordAlert, setIncorrectPasswordAlert] = useState(false);
    const [inputPassword, setInputPassword] = useState('');
    const { t: translate } = useTranslation();

    const handleSubmitChangeUser = async () => {

        if (inputPassword === ""){
            return setRequiredPasswordAlert(true); 
        }

        const usersDataQuery = await DB.users.toArray();
        const currentUserInfos = usersDataQuery.filter((user) => user.data.personnel_controleur.id === userIdToBeChange);
        const passwordToBeSwitch = currentUserInfos[0].passe;
        const decryptedPasswordToBeSwitch = aesUtil.decrypt(ApiConfig.AesSecretKey, passwordToBeSwitch);
        if (inputPassword !== decryptedPasswordToBeSwitch){
            return setIncorrectPasswordAlert(true);
        }

        setRequiredPasswordAlert(false);
        setIncorrectPasswordAlert(false);

        //sync all data for switch user:
        localStorage.setItem(Constant.localStorageKey.userId, userIdToBeChange);
        localStorage.setItem(Constant.localStorageKey.updateDone, true)
        localStorage.setItem(Constant.localStorageKey.autoSync, true)

        onCancel();
        window.location.replace(process.env.PUBLIC_URL.length === 0 ? "/" : process.env.PUBLIC_URL);
    }

    return (
        <Modal
            open={open}
            onClose={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <box className="logout-modal">
                <h3>{title}</h3>
                <TextField 
                    autoComplete='off'
                    id='usernameInput'
                    error={requiredPasswordAlert || incorrectPasswordAlert ? true : false}
                    helperText = {requiredPasswordAlert ? translate('fieldRequire') : incorrectPasswordAlert ? translate('invalidPassword') : null}
                    sx={{width: '100%'}} 
                    label={translate('password')} 
                    onChange={(e) => {
                        setInputPassword(e.target.value);
                        setRequiredPasswordAlert(false);
                        setIncorrectPasswordAlert(false);
                    }} 
                    margin='normal' 
                    type='password' 
                    placeholder={translate('password')}
                />
                <div className="logout-modal-button">
                    <button className='cancel-btn' onClick={onCancel}>{translate('cancel')}</button>
                    <button className='confirm-btn' onClick={handleSubmitChangeUser}>Ok</button>
                </div>
            </box>
        </Modal>
    )
}

export default ModalChangeUserPasswordInput;